var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"app-bar",attrs:{"app":"","color":"transparent","flat":"","absolute":"","extended":""}},[_vm._t("menu")],2)}
var staticRenderFns = []

export { render, staticRenderFns }